import {
  API_CALL,
  START_SEARCH,
  RECEIVE_SEARCH_RESULTS,
  SEARCH_FAILED,
  CLEAR_SEARCH_RESULTS,
  START_INDEX_JOB,
  RECEIVE_INDEX_JOB_RESULTS,
  INDEX_JOB_FAILED
} from './types';
import { getPreferences } from "../preferences"
export const search = (query) => ({
  type: API_CALL,
  tracking: {
    category: 'Search',
    action: 'Full Text Search',
    label: (a) => a.query
  },
  onRequest: START_SEARCH,
  onResponse: RECEIVE_SEARCH_RESULTS,
  onError: SEARCH_FAILED,
  responseKey: 'results',
  payload: {
    method: 'GET',
    url: `/search/query?minDate=${getPreferences().minDateCutoff || ''}&q=${query}`
  },
  query
});

export const clearSearchResults = () => {
  return {
    type: CLEAR_SEARCH_RESULTS
  }
}

export const setSearchResults = (results, query) => {
  return {
    type: RECEIVE_SEARCH_RESULTS,
    results
  }
};

export const startIndexJob = (index) => ({
  type: API_CALL,
  onRequest: START_INDEX_JOB,
  onResponse: RECEIVE_INDEX_JOB_RESULTS,
  onError: INDEX_JOB_FAILED,
  //responseKey: 'results',
  payload: {
    method: 'GET',
    url: `/search/startindexjob?index=${index}`
  },
  index
});


